import { rem } from 'polished'
import styled from 'styled-components'
import tw, { screen } from 'twin.macro'

export const Root = styled.div`
  ${tw`relative select-none w-full`};
  ${({ $fullscreen }) => !$fullscreen && tw`sticky`};

  top: calc(${rem(90)} + 3rem);
  ${screen`xlnav`({ top: rem(68) })};

  background-color: var(--color-bg);
  overflow: hidden;
  overscroll-behavior: none;

  .swiper {
    width: 100%;
    height: 100%;
  }

  .swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .swiper-button-prev,
  .swiper-rtl .swiper-button-next {
    left: 0rem;
  }

  .swiper-button-next,
  .swiper-rtl .swiper-button-prev {
    right: 0rem;
  }

  .swiper-button-prev,
  .swiper-button-next {
    width: var(--swiper-navigation-size);
    height: var(--swiper-navigation-size);
    padding: 1rem;
    background-color: var(--color-gold);
    margin-top: 0;
    transform: translateY(-50%);
  }

  .swiper-button-prev:after,
  .swiper-button-next:after {
    font-size: calc(var(--swiper-navigation-size) * 0.38);
  }

  .swiper-button-prev:after {
    margin-right: 0.1em;
  }

  .swiper-button-next:after {
    margin-left: 0.1em;
  }

  .swiper-button-next.swiper-button-disabled,
  .swiper-button-prev.swiper-button-disabled {
    opacity: 1;
    background-color: var(--color-grey);
  }

  .swiper-button-prev,
  .swiper-button-next,
  .swiper-button-prev.swiper-button-disabled,
  .swiper-button-next.swiper-button-disabled {
    opacity: 0;
  }

  &:hover {
    .swiper-button-prev,
    .swiper-button-next {
      opacity: 1;
    }
  }
`

export const MainSwiper = styled.div`
  --swiper-navigation-color: var(--color-white);
  --swiper-navigation-size: 2rem;

  @media (min-width: 768px) {
    --swiper-navigation-size: 2.5rem;
  }

  .swiper-zoom-container {
    cursor: zoom-in;
  }

  .swiper-slide-zoomed .swiper-zoom-container {
    /* cursor: zoom-out; */
    cursor: move;
  }

  .swiper-button-next.swiper-button-disabled,
  .swiper-button-prev.swiper-button-disabled {
    background-color: var(--color-grey);
  }

  background-color: var(--color-bg);

  ${({ $fullscreen }) => $fullscreen && tw`fixed top-0 left-0 w-screen h-full z-40`};
  ${({ $fullscreen }) =>
    $fullscreen && {
      // height: 'calc(100vh - env(safe-area-inset-bottom, 20rem))',
      paddingBottom: 'env(safe-area-inset-bottom)',
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridTemplateRows: 'auto min-content',
    }};
`

export const ThumbsSwiper = styled.div`
  ${tw`select-none`};

  --swiper-navigation-color: var(--color-white);
  --swiper-navigation-size: 0.75rem;
  --scrollbarHeight: 3px;
  --swiper-pagination-bullet-size: 6px;

  @media (min-width: 768px) {
    --swiper-navigation-size: 1rem;
  }

  .swiper-slide {
    cursor: pointer;
  }

  .swiper-button-prev,
  .swiper-button-next {
    /* top: 0;
    margin-top: 0;
    height: 100%;
    border-radius: 0; */
  }

  .swiper-button-prev {
    left: 0;
  }

  .swiper-button-next {
    right: 0;
  }

  .swiper-scrollbar {
    ${tw`top-auto bottom-0 left-0 right-0 w-full rounded-none`};
    height: var(--scrollbarHeight);
    background: var(--color-gold-white-line);
  }

  .swiper-scrollbar-drag {
    height: var(--scrollbarHeight);
    border-radius: 0;
    background: var(--color-gold);
  }

  .swiper-slide img {
    object-fit: cover;
  }

  .swiper-button-prev:after,
  .swiper-button-next:after {
    font-size: calc(var(--swiper-navigation-size));

    @media (min-width: 768px) {
      font-size: calc(var(--swiper-navigation-size) * 0.62);
    }
  }

  .swiper {
    ${tw`flex flex-col`};
  }

  .swiper-pagination {
    position: static;
    display: flex;
    align-items: center;
    justify-content: center;
    ${tw`pb-4`};
  }

  .swiper-pagination-bullet-active {
    background: var(--color-gold);
  }
`

export const FullScreenToggle = styled.button`
  ${tw`absolute top-4 right-4 z-10 flex items-center justify-center`}

  ${({ $fullscreen }) => $fullscreen && tw`fixed top-4 right-4 z-50`};

  border-color: var(--color-gold);
  background-color: ${({ $fullscreen }) => ($fullscreen ? 'var(--color-gold)' : 'var(--color-white)')};
  /* background-color: ${({ $fullscreen }) => ($fullscreen ? 'var(--color-gold)' : 'rgba(255,255,255,0.38)')}; */
  border-radius: 3px;

  --toggle-size: 2rem;

  @media (min-width: 768px) {
    --toggle-size: 2.5rem;
  }

  width: var(--toggle-size);
  height: var(--toggle-size);

  svg * {
    fill: ${({ $fullscreen }) => ($fullscreen ? 'var(--color-white)' : 'var(--color-gold)')};
  }
`

export const Hint = styled.div`
  ${tw`pt-1 pb-5`}
  text-align: center;
  color: var(--color-clock-grey);
`
